import * as React from 'react';
import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

// tslint:disable-next-line:variable-name
const SInputLabel = styled.span(
  ({ theme }) => `
  font-size: ${theme.font.size.smaller};
  margin-bottom: ${theme.spacing.smallMedium2}px;
  color: ${theme.colors.grayBlueish};
  line-height: 1.47;
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IInputLabelProps {
  dataAt: string;
  className?: string;
}

// tslint:disable-next-line:variable-name
const InputLabel: React.FC<IInputLabelProps> = (props) => {
  return (
    <SInputLabel data-at={props.dataAt} className={'inputLabel ' + props.className}>
      {props.children}
    </SInputLabel>
  );
};

export default InputLabel;
